
import Vue from 'vue'
import CurrencyRate from '../currency-rate/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

const BANKS_TAG = 'banks'

export default Vue.extend({
  name: 'CurrencyRateList',
  components: { CurrencyRate },
  mixins: [staticBlockMixin],
  data () {
    return {
      currencies: [],
      regions: [],
      currentRegionId: null
    }
  },
  async fetch () {
    try {
      const regions = await this.$shops.fetch(BANKS_TAG)

      const currencies =
        JSON.parse(
          JSON.stringify(
            this.$currencies.currenciesGroupedByOffices.officesCurrencies
          ))

      this.bindCurrenciesToRegions(regions, currencies)

      this.currencies = currencies
      this.regions = regions

      const siteName = this.$authNew.sites?.find(s => s.id === this.$authNew.siteId)?.name
      const regionId = regions?.find(r => r.name === siteName)?.id

      if (regionId) {
        this.currentRegionId = regionId
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    region () {
      return this.regions?.find(r => r.id === this.currentRegionId) || this.regions?.[0]
    },
    firstPointWithCurrencyInfo () {
      return this.region?.shops?.find(shop => shop?.currency?.currency?.currenciesInfo?.length) || this.region?.shops?.[0] || {}
    }
  },
  watch: {
    '$authNew.siteId' (newSiteId: number) {
      const siteName = this.$authNew.sites?.find(s => s.id === newSiteId)?.name
      const regionId = this.regions?.find(r => r.name === siteName)?.id
      if (regionId) {
        this.currentRegionId = regionId
      }
    }
  },
  methods: {
    updateDate () {
      const date = new Date(this.$currencies.currenciesGroupedByOffices.currenciesUpdatedAt * 1000)
      return new Intl.DateTimeFormat('ru-RU', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }).format(date)
    },
    bindCurrenciesToRegions (regions: any[], currencies: any[]) {
      const shops = this.extractShopsFromRegions(regions)
      this.bindCurrenciesToShops(shops, currencies)
    },

    bindCurrenciesToShops (shops: any[], currencies: any[]) {
      let temp
      for (const shop of shops) {
        temp = currencies?.find((currency: { code: string }) => currency.code === shop?.params?.officeCode)
        if (!temp) { continue }
        shop.currency = temp
      }
    },

    extractShopsFromRegions (regions: any[]) {
      const shops: any[] = []
      regions.forEach((region: { shops: any[] }) => shops.push(...region.shops))
      return shops
    }
  }
})
